import React, { useEffect, useState } from "react";
import DTOOffCycleARModal from "./DTOOffCycleARModal";
import OffCycleARModalPresenter from "./OffCycleARModalPresenter";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import { actionRequiredService } from "../../../../api/services/actionRequiredService";
import { useAppSelector } from "../../../../infra/hooks";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  fullData?: any;
  historyData?: any;
}

const OffCycleARModalController = ({
  isModalOpen,
  closeModal,
  fullData,
  historyData,
}: ModalInterface) => {
  const { t } = useTranslation();
  const [allActions, setAllActions] = useState([]);
  const selector = useAppSelector((state) => state.authSlice);
  const getActions = (act: any) => {
    setAllActions(act);
  };
  const hitAction = (payload: any) => {
    actionRequiredService
      .finalActionSubmitActionRequired(payload)
      .then((res: any) => {
        if (res?.response == "success") {
          toast.success("Action Performed Successfully!");
          closeModal();
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.data);
      });
  };
  return (
    <div>
      <DTOOffCycleARModal setAllActions={getActions} />

      <OffCycleARModalPresenter
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        trans={t}
        historyData={historyData}
        fullData={fullData}
        allActions={allActions}
        handleSubmitAR_Request={hitAction}
        userId={selector.user_id}
      />
    </div>
  );
};

export default OffCycleARModalController;
